/**
 * Oleum Vitae — motor de perfil de usuario (rule-based).
 * Convierte respuestas del segmentador en userContext normalizado.
 */
(function (global) {
  'use strict';

  var ROUTES = {
    consumer: '/collections/bienestar-emocional',
    skincare_user: '/collections/skincare-para-el-y-ella',
    haircare_user: '/collections/skincare-para-el-y-ella',
    body_wellness: '/collections/bienestar-corporal',
    home_user: '/collections/hogar-y-espacios',
    sensory_space: '/collections/hogar-y-espacios',
    home_product_maker: '/collections/hogar-y-espacios',
    formulator: '/collections/hogar-y-espacios',
    culinary_user: '/collections/alimentos-y-bebidas',
    mixologist: '/collections/alimentos-y-bebidas',
    pastry: '/collections/alimentos-y-bebidas',
    spa: '/pages/spas-centros-bienestar',
    clinic: '/pages/uso-profesional',
    retail: '/pages/tiendas-naturistas',
    restaurant_cafe: '/collections/alimentos-y-bebidas',
    marketplace: '/pages/marketplaces-tiendas-online',
    distributor_candidate: '/pages/distribuidores'
  };

  var ROUTE_COLLECTION_HANDLES = {
    consumer: 'bienestar-emocional',
    skincare_user: 'skincare-para-el-y-ella',
    haircare_user: 'skincare-para-el-y-ella',
    body_wellness: 'bienestar-corporal',
    home_user: 'hogar-y-espacios',
    sensory_space: 'hogar-y-espacios',
    home_product_maker: 'hogar-y-espacios',
    formulator: 'hogar-y-espacios',
    culinary_user: 'alimentos-y-bebidas',
    mixologist: 'alimentos-y-bebidas',
    pastry: 'alimentos-y-bebidas',
    restaurant_cafe: 'alimentos-y-bebidas'
  };

  var AROMA_MAP = {
    citrico_fresco: 'citrico_fresco',
    floral_suave: 'floral_suave',
    amaderado: 'amaderado',
    herbal_mentolado: 'herbal_mentolado',
    calido_especiado: 'calido_especiado',
    sin_preferencia: 'sin_preferencia',
    citrico: 'citrico_fresco',
    especiado: 'calido_especiado',
    herbal: 'herbal_mentolado',
    floral: 'floral_suave'
  };

  var BENEFIT_MAP = {
    descanso_relajacion: 'descanso_relajacion',
    energia_vitalidad: 'energia_vitalidad',
    enfoque_claridad: 'enfoque_claridad',
    equilibrio_emocional: 'equilibrio_emocional',
    bienestar_general: 'bienestar_general'
  };

  var USE_METHOD_MAP = {
    difusor_aroma: 'difusor_aroma',
    piel_diluido: 'piel_diluido',
    spray: 'spray',
    no_seguro: 'difusor_aroma'
  };

  var EXPERIENCE_MAP = {
    principiante: 'principiante',
    intermedio: 'intermedio',
    frecuente: 'frecuente',
    profesional: 'profesional'
  };

  var STORAGE_KEY = 'oleum_user_context';
  var COOKIE_KEY = 'oleum_ctx';
  var COOKIE_DAYS = 30;

  var INTENT_TO_PRIMARY = {
    bienestar_personal: 'bienestar_personal',
    skincare: 'skincare',
    bienestar_corporal: 'bienestar_corporal',
    hogar_espacios: 'hogar_espacios',
    gastronomia_bebidas: 'cocina_bebidas',
    formulacion: 'hacer_productos',
    negocio_clientes: 'negocio_clientes'
  };

  var URL_CONTEXT_KEYS = [
    'ov_role',
    'ov_profile',
    'ov_intent',
    'ov_primary_use',
    'ov_benefit',
    'ov_aroma',
    'ov_use_method',
    'ov_experience',
    'ov_collection'
  ];

  var BROWSE_COLLECTION_STORAGE_KEY = 'oleum_browse_collection';

  function uniq(arr) {
    var out = [];
    (arr || []).forEach(function (v) {
      if (v && out.indexOf(v) === -1) out.push(v);
    });
    return out;
  }

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setCookie(name, value, days) {
    var maxAge = (days || COOKIE_DAYS) * 24 * 60 * 60;
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function normalizeAroma(val) {
    return AROMA_MAP[val] || val || 'sin_preferencia';
  }

  function normalizeBenefit(val) {
    return BENEFIT_MAP[val] || val || 'bienestar_general';
  }

  /**
   * @param {Record<string, string>} answers
   * @returns {object}
   */
  function buildUserContext(answers) {
    answers = answers || {};
    var ctx = {
      role: 'b2c',
      profile: 'consumer',
      intent: 'bienestar_personal',
      benefit: normalizeBenefit(answers.benefit),
      aroma: normalizeAroma(answers.aroma || answers.perfil_sabor),
      use_method: USE_METHOD_MAP[answers.use_method] || answers.use_method || '',
      experience_level: EXPERIENCE_MAP[answers.experience] || 'principiante',
      business_type: answers.business_type || '',
      business_goal: answers.business_goal || '',
      distributes_oils: answers.distributes_oils || '',
      ambiente: answers.ambiente || '',
      cuidado_area: answers.cuidado_area || '',
      preparacion: answers.preparacion || '',
      wants_kit: answers.wants_kit === 'si',
      tags: [],
      route: ROUTES.consumer,
      primary_use: answers.primary_use || '',
      answers: Object.assign({}, answers),
      created_at: new Date().toISOString()
    };

    var primary = answers.primary_use;

    if (primary === 'bienestar_personal') {
      ctx.role = 'b2c';
      ctx.profile = 'consumer';
      ctx.intent = 'bienestar_personal';
      ctx.tags = uniq(['b2c', 'consumer', 'bienestar_personal', 'guia_simple']);
    } else if (primary === 'skincare') {
      ctx.role = 'b2c';
      ctx.profile = 'skincare_user';
      ctx.intent = 'skincare';
      ctx.tags = uniq(['b2c', 'skincare', 'belleza', 'topico', 'piel_diluido']);
      if (answers.cuidado_area === 'cabello') {
        ctx.profile = 'haircare_user';
        ctx.tags.push('cabello', 'pestanas');
      } else if (answers.cuidado_area === 'rutina_completa') {
        ctx.tags.push('rutina_completa');
      }
      if (ctx.wants_kit) ctx.tags.push('kit_preferido');
    } else if (primary === 'bienestar_corporal') {
      ctx.role = 'b2c';
      ctx.profile = 'body_wellness';
      ctx.intent = 'bienestar_corporal';
      ctx.tags = uniq(['b2c', 'bienestar_corporal', 'topico', 'piel_diluido', 'rutina']);
    } else if (primary === 'hogar_espacios') {
      ctx.role = 'b2c';
      ctx.profile = 'home_user';
      ctx.intent = 'hogar_espacios';
      ctx.tags = uniq(['hogar', 'aroma_hogar', 'difusor_aroma', 'spray']);
      if (answers.contexto_hogar === 'espacio_comercial') {
        ctx.role = 'b2b';
        ctx.profile = 'sensory_space';
        ctx.tags.push('espacio_comercial', 'aromatizacion_profesional');
      }
      if (answers.uso_hogar === 'creacion_productos') {
        ctx.role = 'maker';
        ctx.profile = 'home_product_maker';
        ctx.tags.push('formulacion', 'productos_hogar');
      }
      if (answers.uso_hogar) ctx.use_method = USE_METHOD_MAP[answers.uso_hogar] || answers.uso_hogar;
      if (answers.ambiente) {
        var ambMap = {
          relajante: 'ambiente_relajante',
          energizante: 'ambiente_energizante',
          fresco_limpio: 'fresco_limpio',
          calido_acogedor: 'calido_acogedor'
        };
        if (ambMap[answers.ambiente]) ctx.benefit = ambMap[answers.ambiente];
      }
    } else if (primary === 'cocina_bebidas') {
      ctx.role = 'foodservice';
      ctx.profile = 'culinary_user';
      ctx.intent = 'gastronomia_bebidas';
      ctx.tags = uniq(['gastronomia', 'comestible', 'recetas']);
      if (answers.preparacion === 'mixologia') {
        ctx.profile = 'mixologist';
        ctx.tags.push('mixologia', 'bebidas', 'cocteleria');
      } else if (answers.preparacion === 'reposteria') {
        ctx.profile = 'pastry';
        ctx.tags.push('reposteria');
      }
      ctx.aroma = normalizeAroma(answers.perfil_sabor || answers.aroma);
      ctx.use_method = 'bebidas';
    } else if (primary === 'hacer_productos') {
      ctx.role = 'maker';
      ctx.profile = 'formulator';
      ctx.intent = 'formulacion';
      ctx.tags = uniq(['maker', 'formulacion', 'productos_naturales']);
      ctx.use_method = 'formulacion';
    } else if (primary === 'negocio_clientes') {
      ctx.role = 'b2b';
      ctx.intent = 'negocio_clientes';
      ctx.tags = uniq(['negocio', 'clientes', 'b2b']);
      var bt = answers.business_type;
      if (bt === 'spa') {
        ctx.profile = 'spa';
        ctx.tags.push('spa', 'bienestar', 'venta_directa');
      } else if (bt === 'clinica') {
        ctx.role = 'prescriptor';
        ctx.profile = 'clinic';
        ctx.tags.push('prescriptor', 'consulta', 'uso_profesional', 'guias_seguras');
      } else if (bt === 'tienda_naturista') {
        ctx.profile = 'retail';
        ctx.tags.push('retail', 'reventa', 'catalogo');
      } else if (bt === 'restaurante_cafe') {
        ctx.profile = 'restaurant_cafe';
        ctx.tags.push('gastronomia', 'bebidas', 'foodservice');
      } else if (bt === 'marketplace') {
        ctx.profile = 'marketplace';
        ctx.tags.push('ecommerce', 'reventa', 'distribucion');
      }
      if (answers.business_goal === 'distribucion_info') {
        ctx.role = 'distribuidor';
        ctx.profile = 'distributor_candidate';
        ctx.tags.push('distribuidor', 'programa_comercial');
      }
    }

    if (answers.use_method && primary !== 'hogar_espacios' && primary !== 'cocina_bebidas') {
      ctx.use_method = USE_METHOD_MAP[answers.use_method] || answers.use_method;
    }

    ctx.route = ROUTES[ctx.profile] || ROUTES.consumer;
    ctx.collection_handle = ROUTE_COLLECTION_HANDLES[ctx.profile] || '';
    ctx.tags = uniq(ctx.tags);

    return ctx;
  }

  function persistUserContext(ctx, days) {
    var json = JSON.stringify(ctx);
    try {
      localStorage.setItem(STORAGE_KEY, json);
    } catch (e) {}
    setCookie(COOKIE_KEY, json, days || COOKIE_DAYS);
    return ctx;
  }

  function loadStoredUserContext() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    try {
      var c = getCookie(COOKIE_KEY);
      if (c) return JSON.parse(c);
    } catch (e2) {}
    return null;
  }

  function parseUserContextFromUrl() {
    if (typeof window === 'undefined' || !window.location) return null;
    var params = new URLSearchParams(window.location.search);
    if (!URL_CONTEXT_KEYS.some(function (key) { return params.has(key); })) return null;

    var patch = { answers: {} };

    if (params.has('ov_role')) patch.role = params.get('ov_role');
    if (params.has('ov_profile')) patch.profile = params.get('ov_profile');
    if (params.has('ov_intent')) patch.intent = params.get('ov_intent');
    if (params.has('ov_benefit')) {
      patch.benefit = normalizeBenefit(params.get('ov_benefit'));
      patch.answers.benefit = params.get('ov_benefit');
    }
    if (params.has('ov_aroma')) {
      patch.aroma = normalizeAroma(params.get('ov_aroma'));
      patch.answers.aroma = params.get('ov_aroma');
    }
    if (params.has('ov_use_method')) {
      var method = params.get('ov_use_method') || '';
      patch.use_method = USE_METHOD_MAP[method] || method;
      patch.answers.use_method = method;
    }
    if (params.has('ov_experience')) {
      var exp = params.get('ov_experience') || '';
      patch.experience_level = EXPERIENCE_MAP[exp] || exp;
      patch.answers.experience = exp;
    }
    if (params.has('ov_primary_use')) {
      patch.primary_use = params.get('ov_primary_use');
      patch.answers.primary_use = params.get('ov_primary_use');
    }
    if (params.has('ov_collection')) {
      patch.browse_collection = params.get('ov_collection');
    } else if (params.has('ov_intent')) {
      var primary = INTENT_TO_PRIMARY[params.get('ov_intent')] || '';
      if (primary) {
        patch.primary_use = primary;
        patch.answers.primary_use = primary;
      }
    }

    return patch;
  }

  function mergeUserContext(stored, patch) {
    if (!patch) return stored;
    if (!stored) {
      var baseAnswers = Object.assign(
        {
          primary_use: patch.primary_use || 'bienestar_personal',
          benefit: patch.answers.benefit || 'bienestar_general',
          aroma: patch.answers.aroma || 'sin_preferencia',
          use_method: patch.answers.use_method || '',
          experience: patch.answers.experience || 'principiante'
        },
        patch.answers || {}
      );
      var built = buildUserContext(baseAnswers);
      return Object.assign(built, patch, {
        answers: Object.assign({}, built.answers, patch.answers || {})
      });
    }

    var merged = Object.assign({}, stored, patch);
    merged.answers = Object.assign({}, stored.answers || {}, patch.answers || {});
    if (patch.profile) {
      merged.route = ROUTES[patch.profile] || merged.route;
      merged.collection_handle = ROUTE_COLLECTION_HANDLES[patch.profile] || merged.collection_handle;
    }
    if (patch.benefit) merged.benefit = patch.benefit;
    if (patch.aroma) merged.aroma = patch.aroma;
    if (patch.use_method) merged.use_method = patch.use_method;
    if (patch.experience_level) merged.experience_level = patch.experience_level;
    if (patch.primary_use) merged.primary_use = patch.primary_use;
    if (patch.browse_collection) merged.browse_collection = patch.browse_collection;
    return merged;
  }

  function readBrowseCollectionFromStorage() {
    try {
      return sessionStorage.getItem(BROWSE_COLLECTION_STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function persistBrowseCollection(handle) {
    handle = String(handle || '').trim();
    if (!handle) return '';
    try {
      sessionStorage.setItem(BROWSE_COLLECTION_STORAGE_KEY, handle);
    } catch (e) {}
    return handle;
  }

  function detectBrowseCollectionFromPage() {
    if (typeof window === 'undefined') return '';
    if (window.OleumBrowseContext && window.OleumBrowseContext.collection_handle) {
      return String(window.OleumBrowseContext.collection_handle).trim();
    }
    var el = document.querySelector('[data-collection-handle]');
    if (el) {
      return String(el.getAttribute('data-collection-handle') || '').trim();
    }
    return '';
  }

  function captureBrowseCollection() {
    var handle = detectBrowseCollectionFromPage();
    if (handle) persistBrowseCollection(handle);
    return handle || readBrowseCollectionFromStorage();
  }

  function getBrowseCollection() {
    return readBrowseCollectionFromStorage() || detectBrowseCollectionFromPage();
  }

  function clearBrowseCollection() {
    try {
      sessionStorage.removeItem(BROWSE_COLLECTION_STORAGE_KEY);
    } catch (e) {}
  }

  function recommendationContext(ctx) {
    if (!ctx) return null;
    return Object.assign({}, ctx, { browse_collection: '' });
  }

  function loadUserContext() {
    var stored = loadStoredUserContext();
    var patch = parseUserContextFromUrl();
    return mergeUserContext(stored, patch);
  }

  function hasUrlContextParams() {
    if (typeof window === 'undefined' || !window.location) return false;
    var params = new URLSearchParams(window.location.search);
    return URL_CONTEXT_KEYS.some(function (key) { return params.has(key); });
  }

  function contextToQueryParams(ctx) {
    if (!ctx) return '';
    var fields = [
      ['ov_role', ctx.role],
      ['ov_profile', ctx.profile],
      ['ov_intent', ctx.intent],
      ['ov_primary_use', ctx.primary_use],
      ['ov_benefit', ctx.benefit],
      ['ov_aroma', ctx.aroma],
      ['ov_use_method', ctx.use_method],
      ['ov_experience', ctx.experience_level],
      ['ov_collection', ctx.browse_collection]
    ];
    return fields
      .filter(function (pair) {
        return pair[1];
      })
      .map(function (pair) {
        return pair[0] + '=' + encodeURIComponent(pair[1]);
      })
      .join('&');
  }

  function syncCartAttributes(ctx) {
    if (!ctx || typeof fetch === 'undefined') return Promise.resolve();
    var attrs = {
      oleum_role: ctx.role || '',
      oleum_profile: ctx.profile || '',
      oleum_intent: ctx.intent || '',
      oleum_benefit: ctx.benefit || '',
      oleum_aroma: ctx.aroma || '',
      oleum_use_method: ctx.use_method || '',
      oleum_experience_level: ctx.experience_level || '',
      oleum_recommendation_source: 'oleum_segmentador'
    };
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  /** Casos de prueba en consola: OleumProfileEngine.runSelfTests() */
  function runSelfTests() {
    var cases = [
      {
        name: 'Caso 1 bienestar',
        answers: {
          primary_use: 'bienestar_personal',
          benefit: 'descanso_relajacion',
          aroma: 'floral_suave',
          use_method: 'difusor_aroma',
          experience: 'principiante'
        },
        expect: { role: 'b2c', profile: 'consumer', route: '/collections/bienestar-emocional' }
      },
      {
        name: 'Caso 2 skincare kit',
        answers: {
          primary_use: 'skincare',
          benefit: 'bienestar_general',
          aroma: 'floral_suave',
          use_method: 'piel_diluido',
          experience: 'intermedio',
          cuidado_area: 'piel',
          wants_kit: 'si'
        },
        expect: { profile: 'skincare_user', wants_kit: true }
      },
      {
        name: 'Caso 3 hogar',
        answers: {
          primary_use: 'hogar_espacios',
          benefit: 'bienestar_general',
          aroma: 'citrico_fresco',
          experience: 'principiante',
          ambiente: 'fresco_limpio',
          uso_hogar: 'spray',
          contexto_hogar: 'hogar'
        },
        expect: { profile: 'home_user', use_method: 'spray' }
      },
      {
        name: 'Caso 4 mixología',
        answers: {
          primary_use: 'cocina_bebidas',
          benefit: 'bienestar_general',
          experience: 'intermedio',
          preparacion: 'mixologia',
          perfil_sabor: 'citrico'
        },
        expect: { role: 'foodservice', profile: 'mixologist' }
      },
      {
        name: 'Caso 5 retail',
        answers: {
          primary_use: 'negocio_clientes',
          benefit: 'bienestar_general',
          aroma: 'sin_preferencia',
          experience: 'frecuente',
          business_type: 'tienda_naturista',
          business_goal: 'kits_reventa',
          distributes_oils: 'si'
        },
        expect: { profile: 'retail', role: 'b2b' }
      },
      {
        name: 'Caso 6 prescriptor',
        answers: {
          primary_use: 'negocio_clientes',
          benefit: 'bienestar_general',
          aroma: 'herbal_mentolado',
          experience: 'profesional',
          business_type: 'clinica',
          business_goal: 'uso_producto'
        },
        expect: { role: 'prescriptor', profile: 'clinic' }
      }
    ];

    var passed = 0;
    cases.forEach(function (tc) {
      var ctx = buildUserContext(tc.answers);
      var ok = true;
      Object.keys(tc.expect).forEach(function (k) {
        if (ctx[k] !== tc.expect[k]) ok = false;
      });
      console.log(ok ? '✓' : '✗', tc.name, ctx);
      if (ok) passed++;
    });
    console.log('OleumProfileEngine tests:', passed + '/' + cases.length);
    return passed === cases.length;
  }

  global.OleumProfileEngine = {
    ROUTES: ROUTES,
    buildUserContext: buildUserContext,
    persistUserContext: persistUserContext,
    loadUserContext: loadUserContext,
    parseUserContextFromUrl: parseUserContextFromUrl,
    hasUrlContextParams: hasUrlContextParams,
    contextToQueryParams: contextToQueryParams,
    syncCartAttributes: syncCartAttributes,
    captureBrowseCollection: captureBrowseCollection,
    getBrowseCollection: getBrowseCollection,
    clearBrowseCollection: clearBrowseCollection,
    recommendationContext: recommendationContext,
    runSelfTests: runSelfTests
  };
})(typeof window !== 'undefined' ? window : globalThis);
